import { Component } from '@angular/core';
import { MunilyReservationReviewCardData } from 'src/app/common-components/reservation-review-card/reservation-review-card.types';

@Component({
  selector: 'app-reservation-review-card-playground',
  templateUrl: './reservation-review-card-playground.component.html',
  styleUrls: ['./reservation-review-card-playground.component.scss'],
})
export class ReservationReviewCardPlaygroundComponent {
  data: MunilyReservationReviewCardData = {
    userName: 'María García',
    avatarUrl: '',
    avatarInitials: 'MG',
    unitName: 'Apto 301 - Torre A',
    date: 'Sábado 15 de marzo, 10:00 – 12:00',
    description: 'Todo estuvo perfecto, el espacio muy limpio y organizado.',
  };
}
